<template>
  <v-row dense class="lesson-list">
    <v-col cols="12" v-if="exerciseList && step">
      <v-card outlined v-if="exerciseListStatus === 'FE'" class="header bold">
        <v-card-title>Esta avaliação foi finalizada pelo sistema</v-card-title>
      </v-card>
      <v-card outlined v-else>
        <v-card-title>{{ timer }}</v-card-title>
        <v-divider/>
        <v-card-subtitle>
          <span class="d-block">{{ step.test.test_type.name }}: {{ step.test.name }}</span>
          <span class="d-block">Chamada: {{ step.name }}</span>
        </v-card-subtitle>
      </v-card>
    </v-col>

    <v-col cols="12" v-for="(exercise, key) in exerciseList" :key="`exercise-${key}`">
      <exercise :exercise-prop="exercise" :number="key + 1"></exercise>
    </v-col>

    <v-col cols="12" class="pt-5">
      <v-dialog v-model="dialog" width="500">
        <template v-slot:activator="{ on, attrs }">
          <v-btn depressed block v-bind="attrs" v-on="on">
            Finalizar Prova
          </v-btn>
        </template>
        <v-card>
          <v-card-title>
            Finalizar Prova
          </v-card-title>
          <v-card-text>
            Você está finalizando a prova, verifique suas respostas e, certifique-se de que todas as questões estão respondidas, questões não respondidas serão anuladas. Esse processo é irreversível.
          </v-card-text>
          <v-card-text>
            Deseja finalizar a prova?
          </v-card-text>
          <v-card-actions>
            <v-btn text @click="dialog = false">
              Cancelar
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn text @click="closeTest">
              Finalizar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-col>
  </v-row>
</template>

<script>
import { Enrollment, Step, SalaDeAula } from '@/services/resources'
import Exercise from './Exercise'

const moment = require('moment')
moment.locale('pt-BR')

export default {
  props: [
    'stepId',
    'matriculaId',
    'chamadaId'
  ],
  components: {
    Exercise
  },
  data () {
    return {
      timer: 'Calculando...',
      interval: null,
      endDateTime: null,
      dialog: false,
      step: null,
      exerciseList: null,
      exerciseListInstanceId: null,
      exerciseListStatus: null
    }
  },
  mounted () {
    this.loadStep()
    this.loadExerciseList()
  },
  methods: {
    loadStep () {
      Step.getStep(this.stepId)
        .then((response) => {
          this.step = response.body
        }).catch((error) => {
          if (typeof error.body.message !== 'undefined') {
            this.$toasted.global.error({ message: error.body.message })
          } else {
            this.$toasted.global.error({ message: error.statusText })
          }
        })
    },
    loadExerciseList () {
      Enrollment.getEnrollmentExerciseList(this.matriculaId, this.chamadaId)
        .then((response) => {
          this.exerciseList = response.body.instance_step.exercise_list_instance.instances
          this.exerciseListStatus = response.body.instance_step.exercise_list_instance.status
          this.exerciseListInstanceId = response.body.instance_step.exercise_list_instance_id
          this.endDateTime = moment().add(response.body.instance_step.exercise_list_instance.time_left, 'seconds')
          this.interval = setInterval(this.countdown, 1000)
        }).catch((error) => {
          if (typeof error.body.message !== 'undefined') {
            this.$toasted.global.error({ message: error.body.message })
          } else {
            this.$toasted.global.error({ message: error.statusText })
          }
        })
    },
    countdown () {
      const countDownDate = this.endDateTime.toDate()

      const now = new Date().getTime()

      const distance = countDownDate - now

      const days = Math.floor(distance / (1000 * 60 * 60 * 24))
      const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)).toString().padStart(2, 0)
      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60)).toString().padStart(2, 0)
      const seconds = Math.floor((distance % (1000 * 60)) / 1000).toString().padStart(2, 0)

      this.timer = `Você tem ${days} dias ${hours}:${minutes}:${seconds} restantes.`

      if (distance < 0) {
        clearInterval(this.interval)
        this.timer = 'O tempo de realização da prova se esgotou.'
      }
    },
    closeTest () {
      SalaDeAula.closeTestExercises({ exercise_list_instance_id: this.exerciseListInstanceId })
        .then(() => {
          this.$router.back()
        })
        .catch(error => {
          this.dialog = false
          if (error.status === 422) {
            this.$toasted.error('Dados inválidos')
          } else {
            this.$toasted.error(error.response.data.message)
          }
        })
    }
  }
}
</script>
